import { useModelService } from "@shared/services/api/hooks/useModelService";
import { useMemo } from "react";
import { UseQueryResult, useQuery, UseQueryOptions } from "react-query";
import PublicBasedRefundProtectionRepository, {
  type PublicRefundProtectionMetadataQueryParamsSerializer,
  type PublicRefundProtectionMetadataType,
} from "../../repositories/PublicBasedRefundProtectionRepository";

const usePublicBasedRefundProtectionService = () => {
  const repository = useMemo(
    () => new PublicBasedRefundProtectionRepository(),
    []
  );

  const { queryKeyManager } = useModelService(repository);

  const useGetMetadata = (
    params: PublicRefundProtectionMetadataQueryParamsSerializer,
    queryOptions?: Omit<
      UseQueryOptions<
        PublicRefundProtectionMetadataType,
        unknown,
        PublicRefundProtectionMetadataType,
        string[]
      >,
      "queryKey" | "queryFn"
    >
  ): UseQueryResult<PublicRefundProtectionMetadataType> => {
    const queryKey = queryKeyManager.generateKey([
      "metadata",
      JSON.stringify(params),
    ]);

    return useQuery(
      queryKey,
      () => repository.metadata(params, { showToastOnError: false }),
      queryOptions
    );
  };

  return {
    useGetMetadata,
  };
};

export default usePublicBasedRefundProtectionService;
